import React, { Component } from 'react'
import { connect } from 'react-redux'
import { LocalForm, Control } from 'react-redux-form'
import { FormControl, FormGroup, ControlLabel } from 'react-bootstrap'
import ConfirmPopup from '../../common/confirm-popup'
import { saveOrder } from '../../../actions/orders';

class SaveForLaterDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order_reference: null
    }
  }

  componentDidMount() {
    const { popupActive } = this.props;
    popupActive(true);
  }

  componentWillUnmount() {
    const { popupActive } = this.props;
    popupActive(false);
  }

  handleChange = (value) => {
    this.setState({
      order_reference: value
    })
  };

  render() {
    const { order_reference } = this.state;

    return (
      <ConfirmPopup header="Save your order for later"
        onClose={(result) => this.props.onClose(result, order_reference)}
        confirmLabel="Save">
        <div className="ta-left">
          <p>You can find your saved orders in the My Orders area</p>
          <LocalForm onChange={this.handleChange}>
            <FormGroup controlId="orderReference">
              <ControlLabel>Order reference</ControlLabel>

              <Control.text
                model=".your_reference"
                placeholder="Enter some text..."
                component={FormControl} />
            </FormGroup>
          </LocalForm>
        </div>
      </ConfirmPopup>
    )
  }
};

export default connect()(SaveForLaterDialog)


// WEBPACK FOOTER //
// ./src/components/new-order/save/index.jsx